import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { ASSETCLASS_OPTIONS } from '@/pages/instruments/new-instrument/constants/asset-classes'

export interface AssetClassFormFieldProps {}

export const AssetClassFormField: React.FC<AssetClassFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ asset_class: string | null }>()

  return (
    <FormField
      name="asset_class"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Asset Class</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone="None"
              placeholder={'Select an asset class...'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('asset_class', value ? value : null, { shouldValidate: true })
              }
              options={ASSETCLASS_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
